function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

import { h } from 'preact';
import { UIPlugin } from '@uppy/core';
import getFileTypeExtension from '@uppy/utils/lib/getFileTypeExtension';
import supportsMediaRecorder from './supportsMediaRecorder.js';
import RecordingScreen from "./RecordingScreen.js";
import PermissionsScreen from "./PermissionsScreen.js";
import locale from './locale.js';
var packageJson = {
  "version": "1.0.4"
};
/**
 * Audio recording plugin
 */

var _stream = /*#__PURE__*/_classPrivateFieldLooseKey("stream");

var _audioActive = /*#__PURE__*/_classPrivateFieldLooseKey("audioActive");

var _recordingChunks = /*#__PURE__*/_classPrivateFieldLooseKey("recordingChunks");

var _recorder = /*#__PURE__*/_classPrivateFieldLooseKey("recorder");

var _capturedMediaFile = /*#__PURE__*/_classPrivateFieldLooseKey("capturedMediaFile");

var _mediaDevices = /*#__PURE__*/_classPrivateFieldLooseKey("mediaDevices");

var _supportsUserMedia = /*#__PURE__*/_classPrivateFieldLooseKey("supportsUserMedia");

var _hasAudioCheck = /*#__PURE__*/_classPrivateFieldLooseKey("hasAudioCheck");

var _start = /*#__PURE__*/_classPrivateFieldLooseKey("start");

var _startRecording = /*#__PURE__*/_classPrivateFieldLooseKey("startRecording");

var _stopRecording = /*#__PURE__*/_classPrivateFieldLooseKey("stopRecording");

var _discardRecordedAudio = /*#__PURE__*/_classPrivateFieldLooseKey("discardRecordedAudio");

var _submit = /*#__PURE__*/_classPrivateFieldLooseKey("submit");

var _stop = /*#__PURE__*/_classPrivateFieldLooseKey("stop");

var _getAudio = /*#__PURE__*/_classPrivateFieldLooseKey("getAudio");

var _changeSource = /*#__PURE__*/_classPrivateFieldLooseKey("changeSource");

var _updateSources = /*#__PURE__*/_classPrivateFieldLooseKey("updateSources");

var Audio = /*#__PURE__*/function (_UIPlugin) {
  _inherits(Audio, _UIPlugin);

  var _super = _createSuper(Audio);

  function Audio(uppy, opts) {
    var _this2;

    _classCallCheck(this, Audio);

    var _this;

    _this2 = _super.call(this, uppy, opts);
    _this = _assertThisInitialized(_this2);
    Object.defineProperty(_assertThisInitialized(_this2), _getAudio, {
      value: _getAudio2
    });
    Object.defineProperty(_assertThisInitialized(_this2), _hasAudioCheck, {
      value: _hasAudioCheck2
    });
    Object.defineProperty(_assertThisInitialized(_this2), _stream, {
      writable: true,
      value: null
    });
    Object.defineProperty(_assertThisInitialized(_this2), _audioActive, {
      writable: true,
      value: false
    });
    Object.defineProperty(_assertThisInitialized(_this2), _recordingChunks, {
      writable: true,
      value: null
    });
    Object.defineProperty(_assertThisInitialized(_this2), _recorder, {
      writable: true,
      value: null
    });
    Object.defineProperty(_assertThisInitialized(_this2), _capturedMediaFile, {
      writable: true,
      value: null
    });
    Object.defineProperty(_assertThisInitialized(_this2), _mediaDevices, {
      writable: true,
      value: null
    });
    Object.defineProperty(_assertThisInitialized(_this2), _supportsUserMedia, {
      writable: true,
      value: null
    });
    Object.defineProperty(_assertThisInitialized(_this2), _start, {
      writable: true,
      value: function value(options) {
        if (options === void 0) {
          options = null;
        }

        if (!_classPrivateFieldLooseBase(_this, _supportsUserMedia)[_supportsUserMedia]) {
          return Promise.reject(new Error('Microphone access not supported'));
        }

        _classPrivateFieldLooseBase(_this, _audioActive)[_audioActive] = true;

        _classPrivateFieldLooseBase(_this, _hasAudioCheck)[_hasAudioCheck]().then(function (hasAudio) {
          _this.setPluginState({
            hasAudio: hasAudio
          }); // ask user for access to their camera


          return _classPrivateFieldLooseBase(_this, _mediaDevices)[_mediaDevices].getUserMedia({
            audio: true
          }).then(function (stream) {
            _classPrivateFieldLooseBase(_this, _stream)[_stream] = stream;
            var currentDeviceId = null;
            var tracks = stream.getAudioTracks();

            if (!options || !options.deviceId) {
              currentDeviceId = tracks[0].getSettings().deviceId;
            } else {
              tracks.forEach(function (track) {
                if (track.getSettings().deviceId === options.deviceId) {
                  currentDeviceId = track.getSettings().deviceId;
                }
              });
            } // Update the sources now, so we can access the names.


            _classPrivateFieldLooseBase(_this, _updateSources)[_updateSources]();

            _this.setPluginState({
              currentDeviceId: currentDeviceId,
              audioReady: true
            });
          }).catch(function (err) {
            _this.setPluginState({
              audioReady: false,
              cameraError: err
            });

            _this.uppy.info(err.message, 'error');
          });
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _startRecording, {
      writable: true,
      value: function value() {
        // only used if supportsMediaRecorder() returned true
        // eslint-disable-next-line compat/compat
        _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recorder)[_recorder] = new MediaRecorder(_classPrivateFieldLooseBase(_assertThisInitialized(_this2), _stream)[_stream]);
        _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recordingChunks)[_recordingChunks] = [];
        var stoppingBecauseOfMaxSize = false;

        _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recorder)[_recorder].addEventListener('dataavailable', function (event) {
          _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recordingChunks)[_recordingChunks].push(event.data);

          var restrictions = _this2.uppy.opts.restrictions;

          if (_classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recordingChunks)[_recordingChunks].length > 1 && restrictions.maxFileSize != null && !stoppingBecauseOfMaxSize) {
            var totalSize = _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recordingChunks)[_recordingChunks].reduce(function (acc, chunk) {
              return acc + chunk.size;
            }, 0); // Exclude the initial chunk from the average size calculation because it is likely to be a very small outlier


            var averageChunkSize = (totalSize - _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recordingChunks)[_recordingChunks][0].size) / (_classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recordingChunks)[_recordingChunks].length - 1);
            var expectedEndChunkSize = averageChunkSize * 3;
            var maxSize = Math.max(0, restrictions.maxFileSize - expectedEndChunkSize);

            if (totalSize > maxSize) {
              stoppingBecauseOfMaxSize = true;

              _this2.uppy.info(_this2.i18n('recordingStoppedMaxSize'), 'warning', 4000);

              _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _stopRecording)[_stopRecording]();
            }
          }
        }); // use a "time slice" of 500ms: ondataavailable will be called each 500ms
        // smaller time slices mean we can more accurately check the max file size restriction


        _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recorder)[_recorder].start(500); // Start the recordingLengthTimer if we are showing the recording length.


        _this2.recordingLengthTimer = setInterval(function () {
          var currentRecordingLength = _this2.getPluginState().recordingLengthSeconds;

          _this2.setPluginState({
            recordingLengthSeconds: currentRecordingLength + 1
          });
        }, 1000);

        _this2.setPluginState({
          isRecording: true
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _stopRecording, {
      writable: true,
      value: function value() {
        var stopped = new Promise(function (resolve) {
          _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recorder)[_recorder].addEventListener('stop', function () {
            resolve();
          });

          _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recorder)[_recorder].stop();

          clearInterval(_this2.recordingLengthTimer);

          _this2.setPluginState({
            recordingLengthSeconds: 0
          });
        });
        return stopped.then(function () {
          _this2.setPluginState({
            isRecording: false
          });

          return _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _getAudio)[_getAudio]();
        }).then(function (file) {
          try {
            _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _capturedMediaFile)[_capturedMediaFile] = file; // create object url for capture result preview

            _this2.setPluginState({
              recordedAudio: URL.createObjectURL(file.data)
            });
          } catch (err) {
            // Logging the error, exept restrictions, which is handled in Core
            if (!err.isRestriction) {
              _this2.uppy.log(err);
            }
          }
        }).then(function () {
          _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recordingChunks)[_recordingChunks] = null;
          _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recorder)[_recorder] = null;
        }, function (error) {
          _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recordingChunks)[_recordingChunks] = null;
          _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recorder)[_recorder] = null;
          throw error;
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _discardRecordedAudio, {
      writable: true,
      value: function value() {
        _this2.setPluginState({
          recordedAudio: null
        });

        _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _capturedMediaFile)[_capturedMediaFile] = null;
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _submit, {
      writable: true,
      value: function value() {
        try {
          if (_classPrivateFieldLooseBase(_assertThisInitialized(_this2), _capturedMediaFile)[_capturedMediaFile]) {
            _this2.uppy.addFile(_classPrivateFieldLooseBase(_assertThisInitialized(_this2), _capturedMediaFile)[_capturedMediaFile]);
          }
        } catch (err) {
          // Logging the error, exept restrictions, which is handled in Core
          if (!err.isRestriction) {
            _this2.uppy.log(err, 'warning');
          }
        }
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _stop, {
      writable: true,
      value: function () {
        var _value = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var audioTracks;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (_classPrivateFieldLooseBase(_assertThisInitialized(_this2), _stream)[_stream]) {
                    audioTracks = _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _stream)[_stream].getAudioTracks();
                    audioTracks.forEach(function (track) {
                      return track.stop();
                    });
                  }

                  if (!_classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recorder)[_recorder]) {
                    _context.next = 4;
                    break;
                  }

                  _context.next = 4;
                  return new Promise(function (resolve) {
                    _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recorder)[_recorder].addEventListener('stop', resolve, {
                      once: true
                    });

                    _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recorder)[_recorder].stop();

                    clearInterval(_this2.recordingLengthTimer);
                  });

                case 4:
                  _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recordingChunks)[_recordingChunks] = null;
                  _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recorder)[_recorder] = null;
                  _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _audioActive)[_audioActive] = false;
                  _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _stream)[_stream] = null;

                  _this2.setPluginState({
                    recordedAudio: null,
                    isRecording: false,
                    recordingLengthSeconds: 0
                  });

                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function value() {
          return _value.apply(this, arguments);
        }

        return value;
      }()
    });
    Object.defineProperty(_assertThisInitialized(_this2), _changeSource, {
      writable: true,
      value: function value(deviceId) {
        _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _stop)[_stop]();

        _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _start)[_start]({
          deviceId: deviceId
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _updateSources, {
      writable: true,
      value: function value() {
        _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _mediaDevices)[_mediaDevices].enumerateDevices().then(function (devices) {
          _this2.setPluginState({
            audioSources: devices.filter(function (device) {
              return device.kind === 'audioinput';
            })
          });
        });
      }
    });
    _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _mediaDevices)[_mediaDevices] = navigator.mediaDevices;
    _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _supportsUserMedia)[_supportsUserMedia] = _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _mediaDevices)[_mediaDevices] != null;
    _this2.id = _this2.opts.id || 'Audio';
    _this2.type = 'acquirer';

    _this2.icon = function () {
      return h("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "32px",
        height: "32px",
        viewBox: "0 0 32 32"
      }, h("g", {
        fill: "none",
        "fill-rule": "evenodd"
      }, h("rect", {
        fill: "#9B59B6",
        width: "32",
        height: "32",
        rx: "16"
      }), h("path", {
        d: "M16 20c-2.21 0-4-1.71-4-3.818V9.818C12 7.71 13.79 6 16 6s4 1.71 4 3.818v6.364C20 18.29 18.21 20 16 20zm-6.364-7h.637c.351 0 .636.29.636.65v1.95c0 3.039 2.565 5.477 5.6 5.175 2.645-.264 4.582-2.692 4.582-5.407V13.65c0-.36.285-.65.636-.65h.637c.351 0 .636.29.636.65v1.631c0 3.642-2.544 6.888-6.045 7.382v1.387h2.227c.351 0 .636.29.636.65v.65c0 .36-.285.65-.636.65h-6.364a.643.643 0 0 1-.636-.65v-.65c0-.36.285-.65.636-.65h2.227v-1.372C11.637 22.2 9 19.212 9 15.6v-1.95c0-.36.285-.65.636-.65z",
        fill: "#FFF",
        "fill-rule": "nonzero"
      })));
    };

    _this2.defaultLocale = locale;
    _this2.opts = _objectSpread({}, opts);

    _this2.i18nInit();

    _this2.title = _this2.i18n('pluginNameAudio');

    _this2.setPluginState({
      hasAudio: false,
      audioReady: false,
      cameraError: null,
      recordingLengthSeconds: 0,
      audioSources: [],
      currentDeviceId: null
    });

    return _this2;
  }

  _createClass(Audio, [{
    key: "render",
    value: function render() {
      if (!_classPrivateFieldLooseBase(this, _audioActive)[_audioActive]) {
        _classPrivateFieldLooseBase(this, _start)[_start]();
      }

      var audioState = this.getPluginState();

      if (!audioState.audioReady || !audioState.hasAudio) {
        return h(PermissionsScreen, {
          icon: this.icon,
          i18n: this.i18n,
          hasAudio: audioState.hasAudio
        });
      }

      return h(RecordingScreen // eslint-disable-next-line react/jsx-props-no-spreading
      , _extends({}, audioState, {
        audioActive: _classPrivateFieldLooseBase(this, _audioActive)[_audioActive],
        onChangeSource: _classPrivateFieldLooseBase(this, _changeSource)[_changeSource],
        onStartRecording: _classPrivateFieldLooseBase(this, _startRecording)[_startRecording],
        onStopRecording: _classPrivateFieldLooseBase(this, _stopRecording)[_stopRecording],
        onDiscardRecordedAudio: _classPrivateFieldLooseBase(this, _discardRecordedAudio)[_discardRecordedAudio],
        onSubmit: _classPrivateFieldLooseBase(this, _submit)[_submit],
        onStop: _classPrivateFieldLooseBase(this, _stop)[_stop],
        i18n: this.i18n,
        showAudioSourceDropdown: this.opts.showAudioSourceDropdown,
        supportsRecording: supportsMediaRecorder(),
        recording: audioState.isRecording,
        stream: _classPrivateFieldLooseBase(this, _stream)[_stream]
      }));
    }
  }, {
    key: "install",
    value: function install() {
      var _this3 = this;

      this.setPluginState({
        audioReady: false,
        recordingLengthSeconds: 0
      });
      var target = this.opts.target;

      if (target) {
        this.mount(target, this);
      }

      if (_classPrivateFieldLooseBase(this, _mediaDevices)[_mediaDevices]) {
        _classPrivateFieldLooseBase(this, _updateSources)[_updateSources]();

        _classPrivateFieldLooseBase(this, _mediaDevices)[_mediaDevices].ondevicechange = function () {
          _classPrivateFieldLooseBase(_this3, _updateSources)[_updateSources]();

          if (_classPrivateFieldLooseBase(_this3, _stream)[_stream]) {
            var restartStream = true;

            var _this3$getPluginState = _this3.getPluginState(),
                audioSources = _this3$getPluginState.audioSources,
                currentDeviceId = _this3$getPluginState.currentDeviceId;

            audioSources.forEach(function (audioSource) {
              if (currentDeviceId === audioSource.deviceId) {
                restartStream = false;
              }
            });

            if (restartStream) {
              _classPrivateFieldLooseBase(_this3, _stop)[_stop]();

              _classPrivateFieldLooseBase(_this3, _start)[_start]();
            }
          }
        };
      }
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      if (_classPrivateFieldLooseBase(this, _stream)[_stream]) {
        _classPrivateFieldLooseBase(this, _stop)[_stop]();
      }

      this.unmount();
    }
  }]);

  return Audio;
}(UIPlugin);

export { Audio as default };

function _hasAudioCheck2() {
  if (!_classPrivateFieldLooseBase(this, _mediaDevices)[_mediaDevices]) {
    return Promise.resolve(false);
  }

  return _classPrivateFieldLooseBase(this, _mediaDevices)[_mediaDevices].enumerateDevices().then(function (devices) {
    return devices.some(function (device) {
      return device.kind === 'audioinput';
    });
  });
}

function _getAudio2() {
  // Sometimes in iOS Safari, Blobs (especially the first Blob in the recordingChunks Array)
  // have empty 'type' attributes (e.g. '') so we need to find a Blob that has a defined 'type'
  // attribute in order to determine the correct MIME type.
  var mimeType = _classPrivateFieldLooseBase(this, _recordingChunks)[_recordingChunks].find(function (blob) {
    var _blob$type;

    return ((_blob$type = blob.type) == null ? void 0 : _blob$type.length) > 0;
  }).type;

  var fileExtension = getFileTypeExtension(mimeType);

  if (!fileExtension) {
    return Promise.reject(new Error("Could not retrieve recording: Unsupported media type \"".concat(mimeType, "\"")));
  }

  var name = "audio-".concat(Date.now(), ".").concat(fileExtension);
  var blob = new Blob(_classPrivateFieldLooseBase(this, _recordingChunks)[_recordingChunks], {
    type: mimeType
  });
  var file = {
    source: this.id,
    name: name,
    data: new Blob([blob], {
      type: mimeType
    }),
    type: mimeType
  };
  return Promise.resolve(file);
}

Audio.VERSION = packageJson.version;